export default {
	props: {
		room_id: Number,
		price: Number,
		max_room_qty: Number,
		currency: String,
		precision: {type:Number, default: 0},
		value:{type:Number, default: 0},
	},
	data(){
		return {
			selected_qty: 0,
		}
	},
	watch: {
		value:{
			immediate: true,
			handler(){
				let tmp = typeof(this.value)!=='undefined'&&this.value!==null ? this.value : 0;
				if(this.selected_qty!==tmp){
					this.selected_qty = tmp;
				}
			},
		},
		selected_qty:{
			handler(){
				if(this.selected_qty>0){
					this.$emit('change', this.selected_qty);
				}
				else {
					this.$emit('delete');
				}
			},
		}
	},
	computed:{
		cp_options(){
			let restRoomQty = this.max_room_qty - this.$root.getSelectedRoomQty(this.room_id) + this.selected_qty;

			let options = {}
			for(let cnt=1;cnt<=restRoomQty;cnt++){
				options[cnt] = {
					label:`x ${cnt} = ${formatAmount(cnt*this.price, this.currency, this.precision, false, this.$i18n.locale)}`,
					value: cnt
				}
			}
			return options;
		}
	},
	template: `
<qit-select
	class="w-100 v3"
	:label="$t('selectOption')"
	:label-value="0"
	:options="cp_options"
	clearable
	:disabled="Object.values(cp_options).length==0"
	v-model="selected_qty"
/>
`,
}
